/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'draggable': {
    width: 200,
    height: 172,
    viewBox: '0 0 200 172',
    data: '<g fill-rule="evenodd" _fill="#c1c2c2"><path pid="0" d="M200 8.54c0-4.67-3.89-8.54-8.57-8.54H8.57C3.89 0 0 3.87 0 8.54c0 4.67 3.89 8.55 8.57 8.55h182.86c4.68 0 8.57-3.88 8.57-8.55zM200 85.997c0-4.67-3.89-8.54-8.57-8.54H8.57c-4.68 0-8.57 3.87-8.57 8.54 0 4.67 3.89 8.55 8.57 8.55h182.86c4.68 0 8.57-3.88 8.57-8.55zM200 163.454c0-4.67-3.89-8.54-8.57-8.54H8.57c-4.68 0-8.57 3.87-8.57 8.54 0 4.67 3.89 8.55 8.57 8.55h182.86c4.68 0 8.57-3.88 8.57-8.55z"/></g>'
  }
})
